import PropTypes from "prop-types";

const HomesGlobeSmallIcon = ({ width = 42, height = 30, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 42 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M22.9927 17.0507C22.7431 19.4489 20.7211 18.309 19.7242 19.3785C17.9696 21.2494 22.4326 23.6896 21.1505 24.6498C20.2442 25.3253 17.4659 23.9158 16.9742 23.1024C18.6916 26.4068 22.131 28.6627 26.0919 28.6627C31.7732 28.6627 36.3818 24.0161 36.3818 18.2835C36.3818 17.0297 36.162 15.8299 35.7578 14.7184C35.3671 16.1984 32.8503 17.1001 33.0212 17.9555C33.1044 18.3869 33.4372 18.4423 33.296 18.9112C33.0762 19.6451 31.9738 19.9268 31.7821 20.7057C31.4746 21.955 32.5472 24.085 31.2621 25.1216C29.8403 26.2705 30.6634 24.3502 30.5044 23.784C30.2964 23.029 28.6324 21.7003 28.1124 20.9783C26.7233 19.049 27.5211 19.3096 28.8909 18.4153C29.7735 17.8401 29.769 16.507 30.9367 16.2928C31.3156 16.2209 31.8817 16.4695 32.1684 16.2838C32.776 15.9018 32.2887 15.2442 32.6468 14.9461C33.0672 14.5896 33.4208 15.0719 33.7447 14.678C34.0478 14.305 33.5575 13.8736 33.0999 13.6639C31.8311 13.1396 32.5918 12.9179 31.4404 12.1584C29.3738 10.7908 28.5448 11.5338 28.0471 11.0844C27.3904 10.4927 29.2029 9.4996 29.4986 8.48849C28.6458 8.18591 27.747 7.99417 26.808 7.93426H26.8035V7.92976H26.7991C26.5658 7.91328 26.3296 7.9043 26.0919 7.9043C25.0237 7.9043 23.9911 8.06757 23.018 8.37465C22.498 8.53793 21.9988 8.74314 21.5159 8.98731C21.5159 8.98731 21.513 8.9888 21.507 8.9918C19.6306 9.93101 18.0795 11.4319 17.0737 13.2774L17.0692 13.2819C16.8612 13.6594 16.6785 14.0488 16.5195 14.4563C16.5195 14.4563 17.0811 15.1903 17.6962 15.3371C18.5995 15.5513 19.1522 14.8128 19.9916 14.5701C21.7016 14.0713 23.1651 15.3835 22.9912 17.0492L22.9927 17.0507Z"
      fill="#7B9D7C"
    />
    <path
      d="M23.0156 8.37705C23.2816 9.0661 24.696 9.76264 25.3794 9.55593C26.2455 9.29529 25.9335 8.06248 26.816 7.93066L23.0171 8.37555L23.0156 8.37705Z"
      fill="#7B9D7C"
    />
    <path
      d="M21.5185 8.98535C21.5794 9.50963 21.2124 10.1972 21.364 11.0825C21.4397 11.5229 22.2762 12.5654 21.6151 12.7542C21.1099 12.8995 20.5082 12.4066 19.8159 12.5115C19.4355 12.5699 19.2067 12.7557 18.9601 13.0807C18.2871 13.966 17.4819 13.4372 17.0703 13.2844L21.5185 8.98535Z"
      fill="#7B9D7C"
    />
    <path
      d="M23.0166 5.80367L20.4419 3.70505L18.2892 1.95097C17.68 1.45515 16.8094 1.45515 16.2003 1.95097L10.9557 6.22459C10.8131 6.34143 10.6007 6.23807 10.6007 6.05382V3.54178C10.6007 3.24069 10.3585 2.99802 10.0614 2.99802H7.15384C6.85522 2.99802 6.61454 3.24219 6.61454 3.54178V9.59196C6.61454 9.65786 6.58482 9.72078 6.5343 9.76272L3.62234 12.1564C2.94337 12.7152 2.93743 13.7592 3.61045 14.3254L3.6164 14.3299C4.12748 14.7583 4.86735 14.7643 5.38288 14.3434L16.8406 5.01275C17.0635 4.8315 17.3814 4.8315 17.6057 5.01275L19.9071 6.91514"
      fill="#7B9D7C"
    />
    <path
      d="M7.82422 10.0376V24.4598H12.4997"
      stroke="#7B9D7C"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

HomesGlobeSmallIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

HomesGlobeSmallIcon.defaultProps = {
  width: 42,
  height: 30
};

export default HomesGlobeSmallIcon;
